import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BrushIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23.0947 0.90485C22.5488 0.36045 21.7304 0.29885 21.0713 0.73735C18.251 2.51125 15.7363 4.54355 13.8428 6.13135C13.4043 6.52395 12.9541 6.90235 12.5064 7.27975C10.693 8.80675 8.8253 10.3911 7.8209 12.8C7.4679 12.7628 7.1112 12.7673 6.7637 12.8296C5.5093 13.0557 4.4834 13.913 3.875 15.2442C3.7007 15.6251 3.5679 16.0947 3.4141 16.6386C3.0489 17.9286 2.5489 19.6952 1.1265 21.5702C0.956097 21.7948 0.926297 22.0966 1.0494 22.3505C1.1729 22.6054 1.4288 22.7685 1.711 22.7734H1.7872C2.4908 22.7734 7.4674 22.6582 10.1329 19.4707C10.9217 18.5273 11.2518 17.3253 11.1562 16.2009C13.5906 15.2008 15.1839 13.3202 16.7198 11.4952C17.0977 11.0474 17.4766 10.5972 17.8858 10.1402C19.4581 8.26365 21.4903 5.74855 23.253 2.94585C23.7042 2.26905 23.6406 1.44875 23.0947 0.90485ZM8.9819 18.5089C7.4433 20.3486 4.83 20.965 3.1982 21.1709C4.145 19.5646 4.561 18.0947 4.8574 17.0469C4.9946 16.5625 5.1128 16.1447 5.2392 15.8673C5.643 14.9845 6.2621 14.4444 7.0297 14.3058C7.1567 14.2833 7.2865 14.2716 7.4174 14.2716C8.0292 14.2716 8.6591 14.5148 9.0727 14.9278V14.9288C10.0185 15.8741 9.789 17.5431 8.9819 18.5089ZM21.9941 2.13045C20.2685 4.87365 18.2773 7.33695 16.7519 9.15775C16.3486 9.60795 15.9599 10.0694 15.5732 10.5294C14.1268 12.2463 12.7505 13.8633 10.7444 14.7408C10.5817 14.4237 10.3889 14.1228 10.1333 13.8673C9.8821 13.6161 9.586 13.4092 9.2668 13.2402C10.1464 11.2431 11.76 9.86965 13.4726 8.42725C13.9326 8.04005 14.3935 7.65135 14.8242 7.26465C17.5566 4.97505 19.7295 3.35355 21.8867 1.99605C21.957 1.94775 22.0068 1.93945 22.0361 1.96725C22.0713 2.00195 22.0312 2.07375 21.9941 2.13045Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BrushIcon.displayName = 'BrushIcon';
